export enum GeometryType {
    Point = "Point",
    Line = "Line",
    Area = "Area"
}
